import { tns } from 'tiny-slider/src/tiny-slider';

const containers = Array.from(document.querySelectorAll('.Banner'));

containers.forEach((container) => {
    const parent = container.parentNode;
    const nextButtons = Array.from(container.querySelectorAll('.Banner__next-tile'));

    const slider = tns({
        container: container,
        items: 1,
        autoplay: true,
        controlsText: [
            '<span class="w-16 h-16 flex items-center justify-center rounded-full border border-white text-white text-center hover:bg-yellow-500 hover:border-yellow-500"><img src="/themes/bourkeshire/images/arrow_left.svg" alt="Previous" width="13" height="20"></span>',
            '<span class="w-16 h-16 flex items-center justify-center rounded-full border border-white text-white text-center hover:bg-yellow-500 hover:border-yellow-500"><img src="/themes/bourkeshire/images/arrow_right.svg" alt="Next" width="13" height="20"></span>'
        ],
        navContainer: parent.querySelector('.tns-nav'),
        autoplayButtonOutput: false,
        mouseDrag: true
    });

    nextButtons.forEach((button) => {
        button.addEventListener('click', () => slider.goTo('next'));
    });
});
